import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatRippleModule } from '@angular/material/core';

@Component({
  selector: 'ctr-chip',
  imports: [MatRippleModule],
  templateUrl: './chip.component.html',
  styleUrl: './chip.component.scss',
})
export class ChipComponent {
  @Input() active = false;
  @Output() action: EventEmitter<void> = new EventEmitter();

  clickChip() {
    this.action.emit();
  }
}
